import { BrowserModule, Title } from '@angular/platform-browser';
import { importProvidersFrom, LOCALE_ID, NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ThemeModule } from '@theme/theme.module';
import { AppRoutingModule } from './app.routing';
import { HttpClientModule } from '@angular/common/http';
import { LocationStrategy, HashLocationStrategy, registerLocaleData } from '@angular/common';
import { PartialsModule } from '@partials/partials.module';
import { TranslateModule } from '@ngx-translate/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreRouterConnectingModule, RouterState } from '@ngrx/router-store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';

/*Cookies*/
import { CookieService } from 'ngx-cookie-service';
import { EffectsArray } from '@core/store/effects';
import { metaReducers, reducers } from '@core/store';

import localeEs from '@angular/common/locales/es';
import { environment } from 'environments/environment';
import { ServiceWorkerModule } from '@angular/service-worker';
import { SwUpdateNotifierService } from '@utils/services/sw-update-notifier.service';
import { NgxMaskDirective, NgxMaskPipe } from 'ngx-mask';
import { interceptors } from '@core/security/interceptors/interceptors';
import { NgIdleModule } from '@ng-idle/core';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';

registerLocaleData(localeEs, 'es');

@NgModule({
	declarations: [AppComponent],
	imports: [
		NgIdleModule.forRoot(),
		NgIdleKeepaliveModule.forRoot(),
		BrowserModule,
		BrowserAnimationsModule,
		ThemeModule,
		HttpClientModule,
		AppRoutingModule,
		PartialsModule,
		NgxMaskDirective,
		NgxMaskPipe,
		// METRONIC
		TranslateModule.forRoot(),
		// NGRX
		StoreModule.forRoot(reducers, { metaReducers }),
		// eslint-disable-next-line @typescript-eslint/no-unsafe-argument
		EffectsModule.forRoot(EffectsArray),
		StoreRouterConnectingModule.forRoot({
			stateKey: 'router',
			routerState: RouterState.Minimal,
		}),
		StoreDevtoolsModule.instrument({ connectInZone: true }),
		ServiceWorkerModule.register('ngsw-worker.js', {
			enabled: environment.production,
			registrationStrategy: 'registerWhenStable:30000',
		}),
		ServiceWorkerModule.register('ngsw-worker.js', {
			enabled: environment.production || environment.enableServiceWorker,
			registrationStrategy: environment.production
				? 'registerWhenStable:30000' // Producción: espera 30s para estabilidad
				: 'registerWhenStable:5000', // Dev/QA: registro rápido para pruebas
		}),
	],
	providers: [
		{
			provide: LocationStrategy,
			useClass: HashLocationStrategy,
		},
		{
			provide: LOCALE_ID,
			useValue: 'es',
		},
		Title,
		CookieService,
		importProvidersFrom(
			ServiceWorkerModule.register('ngsw-worker.js', {
				enabled: environment.production || environment.enableServiceWorker,
				registrationStrategy: environment.production ? 'registerWhenStable:30000' : 'registerWhenStable:5000',
			})
		),
		SwUpdateNotifierService,
		interceptors,
	],
	bootstrap: [AppComponent],
})
export class AppModule {}
